import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

export interface PendingGiftCard {
  merchantId: string;
  gan: string;
}

export interface DeepLinkEvent {
  type: 'giftcard';
  data: PendingGiftCard;
}

@Injectable({
  providedIn: 'root'
})
export class DeepLinkService {
  private deepLinkEvent$ = new Subject<DeepLinkEvent>();

  constructor() {}

  /**
   * Emit a deep link event to be handled by any listening component
   */
  public emitDeepLinkEvent(event: DeepLinkEvent): void {
    console.log('DeepLinkService: Emitting deep link event', event);
    this.deepLinkEvent$.next(event);
  }

  /**
   * Subscribe to deep link events
   */
  public getDeepLinkEvents(): Observable<DeepLinkEvent> {
    return this.deepLinkEvent$.asObservable();
  }

  /**
   * Emit a gift card deep link event
   */
  public emitGiftCardEvent(merchantId: string, gan: string): void {
    this.emitDeepLinkEvent({
      type: 'giftcard',
      data: { merchantId, gan }
    });
  }
}
